import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import { UiKits, Modal } from "../../../Constant";
import BasicModalCart from "./BasicModal";
import SizeModalCart from "./SizesModal";
import FullScreenModals from "./FullScreenModal";
import CenteredModal from "./CenteredModal";
import ToggleBetweenModals from "./ToggleBetweenModals";
import StaticBackdropModal from "./StaticBackdropModal";
import BohoCustomModals from "./BohoCustomModals";

const ModalContainer = () => {
  return (
    <>
      <Breadcrumbs pageTitle={Modal} title={Modal} parent={UiKits} />
      <Container fluid>
        <Row>
          <BasicModalCart />
          <SizeModalCart />
          <FullScreenModals />
          <CenteredModal/>
          <ToggleBetweenModals/>
          <StaticBackdropModal/>
          <BohoCustomModals/>
        </Row>
      </Container>
    </>
  );
};

export default ModalContainer;
